<template><!--详情》名小吃 本店供应-->
    <div class="app">
        <div class="es-he"></div>
        <div class="deta_main dis-cen">
            <div style="width:1200px;height:auto;">
                <div class="eatsn-box-title dis">
                    <div class="eatsn-box-p" :class="tab_title_value == 1?'eatsn-act-p':''" @click="tabTitleClick(1)">本店供应</div>
                    <div class="eatsn-box-p" :class="tab_title_value == 2?'eatsn-act-p':''" @click="tabTitleClick(2)">评价（{{totalCountShow}}）</div>
                </div>

                <div v-if="tab_title_value == 1">
                    <div class="dis">
                        <div class="eatsn-left" v-if="shopGoodsGroupList.length > 0">
                            <div v-for="(item,index) in shopGoodsGroupList" :key="index" class="eatsn-left-p" :class="act_id == item.id?'eatsn-left-act':''" @click="eatsnLeftClick(item.id)">{{item.name}}</div>
                        </div>
                        <div class="eatsn-right" :class="shopGoodsGroupList.length == 0?'eatsn-group-win':''">
                            <div class="dis-end">
                                <div class="dis">
                                    <div @click="eatsnRightClick(1)" class="eatsn-right-p" :class="right_value == 1?'eatsn-right-act-p':''">综合</div>
                                    <div @click="eatsnRightClick(2)" class="eatsn-right-p" :class="right_value == 2?'eatsn-right-act-p':''">销量</div>
                                    <div @click="eatsnRightClick(3)" class="eatsn-right-p" :class="right_value == 3?'eatsn-right-act-p':''" style="margin-right:20px">价格</div>
                                </div>
                            </div>
                            <div class="dis">
                                <div style="padding:0 20px 40px 20px;box-sizing:border-box" v-for="(item2, index2) in listData" :key="index2" @click="sonBoxClick(item2.id)">
                                    <div class="eatsn-box-son">
                                        <img style="width:100%;height:281px" :src="item2.cover" />
                                        <div class="eatsn-pad">
                                            <div class="eatsn-son-p">{{item2.name}}</div>
                                            <div class="dis-between">
                                                <div class="eatsn-son-p2">￥<span style="font-size:20px">{{item2.price}}</span></div>
                                                <div class="eatsn-son-p3">已售 {{item2.salesSum}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-if="tab_title_value == 2">
                    <div style="height:40px" v-if="listData.length > 0"></div>
                    <div v-if="listData.length > 0">
                        <div class="dis-between" v-for="(item3, index3) in listData" :key="index3" style="margin-bottom:40px">
                            <div class="dis">
                                <img v-if="item3.avatar" style="width:40px;height:40px;" :src="item3.avatar" />
                                <img v-else style="width:40px;height:40px;" src="../../assets/image/iocn/eaticon2.png" />
                                <div class="eatsn-ping-p">{{item3.user_name}}</div>
                            </div>
                            <div class="eatsn-wid">
                                <div class="dis-between">
                                    <div class="dis">
                                        <div class="dis">
                                            <div v-for="(item5, index5) in item3.stars" :key="index5" style="margin:auto 0"><img class="eatsn-img-icon" src="../../assets/image/iocn/eaticon4.png" /></div>
                                            <div v-if="item3.no_stars > 1" style="margin:auto 0"><img v-for="item6 in item3.no_stars" :key="item6" class="eatsn-img-icon" src="../../assets/image/iocn/eaticon3.png" /></div>
                                            <img v-else-if="item3.stars == 4" class="eatsn-img-icon" src="../../assets/image/iocn/eaticon3.png" />
                                        </div>
                                        <div style="margin-left:27px">
                                            <div v-if="item3.stars == 5" class="eatsn-ping-p2">非常满意</div>
                                            <div v-else-if="item3.stars == 4" class="eatsn-ping-p2">满&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;意</div>
                                            <div v-else-if="item3.stars == 1" class="eatsn-ping-p2">极&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;差</div>
                                            <div v-else class="eatsn-ping-p2">一&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;般</div>
                                        </div>
                                        
                                    </div>
                                    <div class="eatsn-ping-p2">{{item3.add_date}}</div>
                                </div>
                                <div class="eatsn-ping-p2" style="color: #333333;">{{item3.description}}</div>
                                <div class="dis">
                                    <img v-for="(item4, index4) in item3.v_imglist" :key="index4" class="eatsn-img-icon2" :src="item4" />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div v-else style="line-height:100px;text-align:center">暂无评价</div>
                </div>
                <div class="dis-end eatsn-pagin" style="margin:0 30px 30px 0" v-if="listData.length > 0">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[9, 20, 30, 40]"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div class="es-he"></div>
    </div>
</template>

<style scoped="scoped">
    @import '../../assets/style/base.css';
    .deta_main {width: 100%;height: auto;background: #FFFFFF;}
    .es-he{width:100%;height:40px;background:#F7F6FB}
    .eatsn-pagin >>> .el-pagination.is-background .el-pager li:not(.disabled).active {background-color: #11D165 !important}
</style>

<script>
import {GetMMCShopGoodMoreList, GetEvaluationByShopGoodsID} from '../../api/discount'
export default {
    name: 'addressPopup',
    props: { parentName: { type: Object } },
    data()
    {
        return {
            tab_title_value: 1,
            currentPage: 1,
            PageSize: 9,
            totalCount: 0,
            shopGoodsGroupList: [],
            act_id: '',
            right_value: 1,
            listData: [],
            totalCountShow: 0
        }
    },
    created()
    {
        if (this.parentName.shopGoodsGroupList !== null) this.shopGoodsGroupList = this.parentName.shopGoodsGroupList
        this.listFn()
        console.log(this.parentName,'asd')
    },
    methods:
    {
        sonBoxClick(id) {
            this.$emit( 'childFn', id )
        },
        eatsnLeftClick(id) {
            this.currentPage = 1
            this.act_id = id
            this.listFn()
        },
        tabTitleClick(val) {
            this.currentPage = 1
            this.tab_title_value = val
            this.listFn()
        },
        handleSizeChange(val) {
            this.currentPage = 1
            this.listFn()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.listFn()
        },
        eatsnRightClick(val) {
            this.right_value = val
            this.currentPage = 1
            this.listFn()
        },
        listFn() {
            this.listData = []
            if (this.tab_title_value == 1) {
                let inputData = {
                    PageNo: this.currentPage,
                    PageSize: this.PageSize,
                    Params: {
                    ShopId: this.parentName.ShopId,
                    ShopGood_groupid: this.act_id,
                    PriceDesc: this.right_value == 3?true:'', //价格是否倒序(选填 不排序就传unll)
                    SalesSumDesc: this.right_value == 2?true:'', //销量是否倒序(选填 不要就传unll)
                }}
                GetMMCShopGoodMoreList(inputData).then((res) => {
                    this.listData = res.data.result.data
                    this.totalCount = res.data.result.totalCount
                })
                let inputData2 = {PageNo: this.currentPage, PageSize: this.PageSize, Params: {ShopGoodsId: this.parentName.ShopGoodsId}}
                GetEvaluationByShopGoodsID(inputData2).then((res) => {
                    this.totalCountShow = res.data.result.totalCount
                })
            } else if (this.tab_title_value == 2) {
                let inputData2 = {PageNo: this.currentPage, PageSize: this.PageSize, Params: {ShopGoodsId: this.parentName.ShopGoodsId}}
                GetEvaluationByShopGoodsID(inputData2).then((res) => {
                    this.listData = res.data.result.data
                    for (let i = 0; i < this.listData.length; i++) {
                        let a = this.listData[i].imglist
                        this.listData[i]['v_imglist'] = a.split(',')
                        let b = this.listData[i].stars
                        this.listData[i]['no_stars'] =  5 - Number(b)
                    }
                    this.totalCountShow = res.data.result.totalCount
                    this.totalCount = res.data.result.totalCount
                })
            }
        }
    }
}
</script>
